import { render, staticRenderFns } from "./postitioning-device-info-change-installer-modal.vue?vue&type=template&id=08af70a0"
import script from "./postitioning-device-info-change-installer-modal.vue?vue&type=script&lang=js"
export * from "./postitioning-device-info-change-installer-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports